import { PageHeader } from "../components/PageHeader";
import { Reveal, Overline } from "../components/motion";
import { CREDENTIALS, HERITAGE, HERITAGE_CAPABILITIES, IMAGES } from "../data";

export default function Legacy() {
  return (
    <>
      <PageHeader
        overline="01 — Executive Profile"
        lines={["A proven financial", "foundation."]}
        subtitle="Ashutosh Capital enters its next phase from more than four decades of financial-services experience, established capital relationships and a history across automobile finance, asset-backed transactions, real estate and institutional activity."
      />

      {/* Credentials */}
      <section className="py-20 md:py-28 bg-bg" data-testid="legacy-credentials">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20">
          <Reveal><Overline>The numbers that define our credentials</Overline></Reveal>
          <Reveal delay={0.05}><h2 className="mt-5 font-heading font-bold text-ink text-2xl md:text-3xl max-w-2xl">Track record creates the confidence to build the next platform.</h2></Reveal>
          <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
            {CREDENTIALS.map((c, i) => (
              <Reveal key={c.label} delay={i * 0.04}>
                <div className="bg-bg p-6 lg:p-8 h-full hover:bg-surface transition-colors duration-500 group">
                  <div className="font-heading font-extrabold text-2xl lg:text-3xl text-ink tracking-tight group-hover:text-brand-green transition-colors duration-500">{c.value}</div>
                  <div className="mt-3 font-body text-xs lg:text-sm text-ink/60 leading-snug">{c.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Heritage timeline */}
      <section className="py-20 md:py-28 bg-surface border-t border-ink/10" data-testid="legacy-heritage">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20">
          <div className="grid lg:grid-cols-12 gap-12">
            <div className="lg:col-span-4">
              <Reveal><Overline>Financial Heritage</Overline></Reveal>
              <Reveal delay={0.05}><h2 className="mt-5 font-heading font-extrabold tracking-tighter text-ink text-4xl lg:text-5xl leading-[1]">Built through <span className="font-display italic font-light text-ink/60">multiple cycles.</span></h2></Reveal>
              <Reveal delay={0.1}>
                <div className="mt-10 border border-ink/10 overflow-hidden">
                  <img src={IMAGES.legacy} alt="Institutional finance" className="w-full h-64 object-cover" />
                  <div className="p-6 bg-surface border-t border-ink/10"><div className="overline text-brand-green">Ashutosh Lease Financing Ltd.</div><div className="font-heading text-ink text-sm mt-1">RBI-Registered NBFC · Est. 1983</div></div>
                </div>
              </Reveal>
            </div>
            <div className="lg:col-span-8 border-t border-ink/15">
              {HERITAGE.map((h, i) => (
                <Reveal key={h.year} delay={i * 0.06}>
                  <div className="group grid md:grid-cols-12 gap-4 md:gap-8 py-9 border-b border-ink/12 hover:bg-bg transition-colors duration-500 px-2 md:px-4">
                    <div className="md:col-span-3"><span className="font-display text-4xl md:text-5xl text-ink/30 group-hover:text-brand-green transition-colors duration-500">{h.year}</span></div>
                    <div className="md:col-span-9">
                      <h3 className="font-heading font-bold text-ink text-lg tracking-tight">{h.title}</h3>
                      <p className="mt-2 font-body text-sm text-ink/60 leading-relaxed">{h.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.1}>
            <div className="mt-14 flex flex-wrap gap-3">
              {HERITAGE_CAPABILITIES.map((c) => (
                <span key={c} className="font-heading text-xs tracking-wide text-ink/70 border border-ink/15 px-4 py-2 hover:border-brand-green hover:text-ink transition-colors duration-300">{c}</span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
